import { render, staticRenderFns } from "./DetailLayout.vue?vue&type=template&id=1134c5ce&scoped=true&"
import script from "./DetailLayout.vue?vue&type=script&lang=js&"
export * from "./DetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailLayout.vue?vue&type=style&index=0&id=1134c5ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134c5ce",
  null
  
)

export default component.exports